import React, { forwardRef } from 'react';
import { styled } from '@mui/material';

import TextInput from 'shell/components/TextInput';

const CustomTextInput = styled(TextInput)(({ helperTextPosition }) => {
    const textAlign = {
        start: 'left',
        end: 'right',
    }[helperTextPosition];

    return {
        '& > p.MuiFormHelperText-root': {
            textAlign,
        },
    };
});

export default forwardRef(({ helperTextPosition = 'start', ...rest }, ref) => {
    return <CustomTextInput ref={ref} helperTextPosition={helperTextPosition} {...rest} multiline />;
});
